var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MessageType } from "../../models/message-type";
import { ViewType } from "../../models/view-type";
import { Base } from "../base";
import { ChatAvatar } from "./chat-avatar";
import { ChatText } from "./chat-text";
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message(index, type, avatarSource, avatarWidth, avatarHeight, text, backgroundColor, fontColor, viewType) {
        var _this = _super.call(this) || this;
        _this.maximizeWindow = function (viewType) {
            _this._text.setFullSizeWindow();
            _this._avatar.setFullSizeWindow(viewType);
        };
        _this.minimizeWindow = function () {
            _this._text.setSmallSizeWindow();
            _this._avatar.setSmallSizeWindow();
        };
        _this.replaceText = function (text) {
            _this._text.replaceText(text);
        };
        _this._type = type;
        var message = document.createElement('div');
        message.id = "js_aigo_bot_chat_message_".concat(type, "_").concat(index);
        message.style.color = fontColor;
        _this._avatar = new ChatAvatar(type, avatarSource, viewType, avatarWidth, avatarHeight, null, backgroundColor);
        _this._text = new ChatText(type, text, backgroundColor, fontColor, viewType);
        message.appendChild(_this._avatar.self);
        message.appendChild(_this._text.self);
        if (viewType === ViewType.MobileSmall) {
            _this._avatar.hide();
            if (type === MessageType.Assistant) {
                message.style.marginLeft = '5px';
            }
            else {
                message.style.marginRight = '5px';
            }
        }
        else {
            message.style.display = 'flex';
            message.style.flexDirection = type === MessageType.Assistant ? 'row' : 'row-reverse';
            message.style.alignItems = 'flex-start';
            message.style.gap = '8px';
            message.style.width = '100%';
            message.style.boxSizing = 'border-box';
            message.style.marginTop = '11px';
            if (viewType === ViewType.MobileLarge) {
                message.style.paddingLeft = '8px';
                message.style.paddingRight = '8px';
            }
            _this._avatar.self.style.flex = '0 0 auto';
            _this._avatar.self.style.marginTop = '0';
            _this._text.self.style.flexShrink = '1';
            _this._text.self.style.minWidth = '0';
            _this._text.self.style.boxSizing = 'border-box';
            _this._text.self.style.marginTop = '0';
            _this._text.self.style.marginLeft = '';
        }
        _this.self = message;
        return _this;
    }
    Object.defineProperty(Message.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    return Message;
}(Base));
export { Message };
